/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * How the identity was resolved. Lets the caller tell an in-cluster attached identity apart from local Application Default Credentials or an impersonated service account.
 */
export const IdentitySource = {
  MetadataServer: "metadata_server",
  ApplicationDefaultCredentials: "application_default_credentials",
  Impersonation: "impersonation",
} as const;
/**
 * How the identity was resolved. Lets the caller tell an in-cluster attached identity apart from local Application Default Credentials or an impersonated service account.
 */
export type IdentitySource = OpenEnum<typeof IdentitySource>;

/**
 * Result of a live 'who am I' probe against a platform credential's resolved identity.
 */
export type VerifyPlatformCredentialResult = {
  /**
   * Human-readable detail about the probe outcome (e.g. why the principal is unavailable, or the failure reason).
   */
  detail?: string | undefined;
  /**
   * How the identity was resolved. Lets the caller tell an in-cluster attached identity apart from local Application Default Credentials or an impersonated service account.
   */
  identitySource?: IdentitySource | undefined;
  /**
   * The effective principal the identity resolves to (e.g. a service-account email). May be empty when the resolution source cannot report it.
   */
  principal?: string | undefined;
  /**
   * Whether the credential's identity resolved successfully.
   */
  verified: boolean;
};

/** @internal */
export const IdentitySource$inboundSchema: z.ZodMiniType<
  IdentitySource,
  unknown
> = openEnums.inboundSchema(IdentitySource);

/** @internal */
export const VerifyPlatformCredentialResult$inboundSchema: z.ZodMiniType<
  VerifyPlatformCredentialResult,
  unknown
> = z.pipe(
  z.object({
    detail: z.optional(z.string()),
    identity_source: z.optional(IdentitySource$inboundSchema),
    principal: z.optional(z.string()),
    verified: z.boolean(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "identity_source": "identitySource",
    });
  }),
);

export function verifyPlatformCredentialResultFromJSON(
  jsonString: string,
): SafeParseResult<VerifyPlatformCredentialResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => VerifyPlatformCredentialResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'VerifyPlatformCredentialResult' from JSON`,
  );
}
